import React, { useCallback, useContext } from 'react'
import { maxFlightChildAge, maxFlightInfantAge, maxFlightPassengerCount } from 'constants/flight'
import MessageBanner from 'components/Luxkit/Banners/MessageBanner'
import FlightSearchWidgetDispatchContext from 'contexts/Flights/FlightSearchWidget/flightSearchWidgetDispatchContext'
import FlightSearchWidgetStateContext from 'contexts/Flights/FlightSearchWidget/flightSearchWidgetStateContext'
import { FlightSearchWidgetActions } from 'contexts/Flights/FlightSearchWidget/flightSearchWidgetStateReducer'
import VerticalSpacer from 'components/Common/Spacing/VerticalSpacer'
import OccupancyItemVertical from 'components/Common/OccupancyPicker/OccupancyItemVertical'
import TextLink from 'components/Luxkit/TextLink'
import ContactContext from 'contexts/contactContext'
import styled from 'styled-components'

const TravellersContainer = styled(VerticalSpacer)`
  width: 420px;
`

const capacity = [{
  adults: maxFlightPassengerCount,
  children: maxFlightPassengerCount,
  infants: maxFlightPassengerCount,
  total: maxFlightPassengerCount,
}]

function FlightSearchTravellerSelectContent() {
  const state = useContext(FlightSearchWidgetStateContext)
  const dispatch = useContext(FlightSearchWidgetDispatchContext)
  const contact = useContext(ContactContext)

  const { occupants } = state

  const onChangeOccupants = useCallback(
    (_itemId: number, nextOccupancy: App.Occupants) => {
      dispatch({
        type: FlightSearchWidgetActions.SET_OCCUPANTS,
        occupants: nextOccupancy,
      })
    },
    [dispatch],
  )

  const infants = occupants.infants || 0
  const showInfantsWarning = infants > 0

  return (
    <TravellersContainer gap={24}>
      <OccupancyItemVertical
        itemId={0}
        occupancy={occupants}
        onChange={onChangeOccupants}
        capacities={capacity}
        childVariant="infants"
        maxChildAge={maxFlightChildAge}
        maxInfantAge={maxFlightInfantAge}
        childrenAgeLabel="at time of return flight"
        childrenLabel={`Aged ${maxFlightInfantAge + 1} - ${maxFlightChildAge}`}
      />

      {showInfantsWarning &&
        <MessageBanner
          kind="warning"
          description={
            <>
              1 adult can travel with 1 infant on their lap. To book a seat for an
              infant, <TextLink href={`tel:${contact.local.number}`}>contact us 24/7</TextLink>.
            </>
          }
      />}
    </TravellersContainer>
  )
}

export default FlightSearchTravellerSelectContent
